const config = {
  api: {
    baseUri: process.env.REACT_APP_API_URI,
    uri: process.env.REACT_APP_API_URI + '/graphql'
  },
  pti: {
    token: 'c9yDTLtqFc7qWsxGQl5V16ZSOfkozQ6t',
    issueUrl: 'https://preflighttech.com/api/1/issues'
  },
  app: {
    name: 'kc-react',
    version: 20241117,
  }
};

export default config;
